import { AnchorButton, Button, Card } from '@payaca/ambrosia';
import { FC } from 'react';
import { Link, LinkProps } from 'react-router-dom';

export type TProps = {
  label: string;
  To?: LinkProps['to'];
  href?: string;
  onClick?: () => void;
  isProcessing?: boolean;
};

const LightboxLink: FC<TProps> = (props) => {
  const { To, onClick } = props;

  let Element: any = AnchorButton;
  let extraProps: any = {};
  if (To) {
    extraProps = { as: Link };
  } else if (onClick) {
    Element = Button;
  }

  return (
    <Card className="typography:prose bg-white">
      <Card.Body className="flex flex-col items-center justify-center gap-4">
        <h2>Preview unavailable</h2>

        <Element
          {...extraProps}
          to={To}
          href={props.href}
          target={props.href ? '_blank' : undefined}
          rel={props.href ? 'noopener noreferrer' : undefined}
          onClick={onClick}
          isProcessing={props.isProcessing ?? undefined}
        >
          {props.label}
        </Element>
      </Card.Body>
    </Card>
  );
};

export default LightboxLink;
